var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHiddenEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_16",
    "data-name": "Layer 16"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "m419.72 419.72-327.46-327.45-.07-.08a19 19 0 0 0 -26.78 27l28.67 28.67a332.64 332.64 0 0 0 -88.19 89 34.22 34.22 0 0 0 0 38.38c59.97 88.76 155.04 140.76 250.11 140.11a271.6 271.6 0 0 0 90.46-15.16l46.41 46.41a19 19 0 0 0 26.94-26.79zm-163.72-55.98a107.78 107.78 0 0 1 -98.17-152.18l29.95 29.95a69.75 69.75 0 0 0 82.71 82.71l29.95 29.95a107.23 107.23 0 0 1 -44.44 9.57z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "m506.11 236.81c-59.97-88.81-155.04-140.81-250.11-140.16a271.6 271.6 0 0 0 -90.46 15.16l46 46a107.78 107.78 0 0 1 142.63 142.63l63.74 63.74a332.49 332.49 0 0 0 88.2-89 34.22 34.22 0 0 0 0-38.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "m256 186.26a69.91 69.91 0 0 0 -14.49 1.52l82.71 82.7a69.74 69.74 0 0 0 -68.22-84.22z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiddenEye);
export default __webpack_public_path__ + "static/media/hiddenEye.317f48eadbeb202fdf9eec3c40405e0c.svg";
export { ForwardRef as ReactComponent };